import { render, staticRenderFns } from "./statisticsBox.vue?vue&type=template&id=177b7bd1&scoped=true"
import script from "./statisticsBox.vue?vue&type=script&lang=js"
export * from "./statisticsBox.vue?vue&type=script&lang=js"
import style0 from "./statisticsBox.vue?vue&type=style&index=0&id=177b7bd1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b7bd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177b7bd1')) {
      api.createRecord('177b7bd1', component.options)
    } else {
      api.reload('177b7bd1', component.options)
    }
    module.hot.accept("./statisticsBox.vue?vue&type=template&id=177b7bd1&scoped=true", function () {
      api.rerender('177b7bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/chart/components/statisticsBox.vue"
export default component.exports